import React from 'react'
import { Link } from 'react-router-dom'
import { Icon } from 'antd'
import './index.scss'

export default ({ text, to }) => (
  <Link to={to} className='back-link'>
    <Icon type='arrow-left' size='large' />
    <p>{text}</p>
  </Link>
)